import { useEffect, useState } from 'react';
import { useForm } from 'react-hook-form'
import { createCategory, deleteCategory, updateCategory, getCategory } from '../../api/category.api';
import { useNavigate, useParams } from 'react-router-dom'
import { toast } from 'react-hot-toast';
import { AuthData } from '../Authorization/AuthWrapper';
import { getLocalToken, isLoggedIn, logout } from '../../services/authorizationService';

function CategoryFormPage() {
    const { register, handleSubmit, formState: { errors }, setValue } = useForm();
    const navigate = useNavigate();
    const params = useParams();
    const [category, setCategory] = useState({})
    const {user, forceRefresh} = AuthData();

    useEffect(() => {
        function verifyUser(){
            if(!isLoggedIn){
                logout();
                navigate('/login')
            }
        }
        async function loadCategory() {
            if (params.id) {
                const res = await getCategory(params.id)
                setValue('name', res.data.name)
                setValue('description', res.data.description)
                setValue('color',res.data.color)
                setCategory(res.data)
            }
        }
        verifyUser()
        loadCategory()
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [params.id]);

    const handleSave = handleSubmit(async data => {
        if (params.id) {
            await updateCategory(params.id, data)
            toast.success('Categoría actualizada', {
                position: "bottom-right",
                style: {
                    background: "#101010",
                    color: "#fff"
                }
            })
        } else {
            await createCategory(data);
            toast.success('Categoría creado', {
                position: "bottom-right",
                style: {
                    background: "#101010",
                    color: "#fff"
                }
            })
        }
        forceRefresh(user)
        navigate('/')
    })

    const handleDelete = (async () => {
        const accepted = window.confirm('Seguro de eliminar?');
        if (accepted) {
            await deleteCategory(params.id)
            toast.success('Categoría eliminada', {
                position: "bottom-right",
                style: {
                    background: "#101010",
                    color: "#fff"
                }
            })

            navigate('/')
        }

    })

    return (
        <div className='mx-auto grid grid-cols-3 gap-x-2'>
            <div className='col-span-3 m-3'>
                {params.id ? 'Actualizar categoría':'Agregar nueva categoría'}
            </div>
            <div className='col-span-2 ml-2'>
                <form action="" >
                    <input
                        type="text"
                        placeholder="Nombre"
                        {...register("name", { required: true })}
                        className=' bg-blue-100 p-3 rounded-lg block w-full mb-3'
                    />
                    {errors.name && <span>Campo requerido</span>}

                    <textarea
                        rows="3"
                        placeholder="Descripción"
                        {...register("description", { required: true })}
                        className=' bg-blue-100 p-3 rounded-lg block w-full mb-3'
                    />
                    {errors.description && <span>Campo requerido</span>}

                    <input
                        type="color"
                        placeholder="Color"
                        {...register("color", { required: true })}
                        className=' bg-blue-100 p-3 rounded-lg block w-full mb-3'
                    />
                    {errors.name && <span>Campo requerido</span>}

                </form>
                <button className='bg-blue-400 p-3 rounded-lg block w-full hover:bg-blue-500' onClick={handleSave}>Guardar</button>            
            </div>
            {/* {params.id &&
                <div className=' flex justify-end'>
                    <button
                        className=' bg-red-400 p-3 rounded-lg w-full hover:bg-red-500'
                        onClick={handleDelete}
                    >
                        Eliminar
                    </button>
                </div>
            } */}
        </div>
    )
}
export default CategoryFormPage;